import {
  CREATECONTACT,
  DELETECONTACT,
  GETCONTACT,
  UPDATECONTACT,
  GET_COMMUNICATION_LOGS,
  CREATE_CALL,
  GET_CALLS,
  UPDATE_CALL,
  DELETE_CALL,
  CREATE_NOTE,
  GET_NOTES,
  UPDATE_NOTE,
  DELETE_NOTE,
  CREATE_REMINDER,
  GET_REMINDERS,
  UPDATE_REMINDER,
  DELETE_REMINDER,
  CREATE_MANUAL_SMS,
  GET_MANUAL_SMS,
  UPDATE_MANUAL_SMS,
  DELETE_MANUAL_SMS,
  SEND_MANUAL_EMAIL,
  GET_MANUAL_EMAIL,
  UPDATE_MANUAL_EMAIL,
  DELETE_MANUAL_EMAIL,
} from "../actions/types";

const initialState = {
  contactList: [],
  smsLogs: [],
  emailLogs: [],
  callList: [],
  noteList: [],
  reminderList: [],
  manualSmsList: [],
  manualEmailList: [],
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case CREATECONTACT:
      return {
        ...state,
        contactSaveStatus: action.payload.success,
      };

    case GETCONTACT:
      return {
        ...state,
        contactList: action.payload.data,
      };

    case UPDATECONTACT:
      return {
        ...state,
        contactUpdateStatus: action.payload.success,
      };

    case DELETECONTACT:
      return {
        ...state,
        contactList: state.contactList.filter(
          (item) => item.id !== action.contactId,
        ),
        contactDeleteStatus: action.payload.success,
      };
    case GET_COMMUNICATION_LOGS:
      return { ...state, commLogs: action.payload.data };
    case CREATE_CALL:
      return { ...state, callSaveStatus: action.payload.success };
    case GET_CALLS:
      return { ...state, callList: action.payload.data };
    case UPDATE_CALL:
      return { ...state, callUpdateStatus: action.payload.success };
    case DELETE_CALL:
      return {
        ...state,
        callList: state.callList.filter((item) => item.id !== action.callId),
        callDeleteStatus: action.payload.success,
      };

    case CREATE_NOTE:
      return { ...state, noteSaveStatus: action.payload.success };
    case GET_NOTES:
      return { ...state, noteList: action.payload.data };
    case UPDATE_NOTE:
      return { ...state, noteUpdateStatus: action.payload.success };
    case DELETE_NOTE:
      return {
        ...state,
        noteList: state.noteList.filter((item) => item.id !== action.noteId),
        noteDeleteStatus: action.payload.success,
      };

    case CREATE_REMINDER:
      return { ...state, reminderSaveStatus: action.payload.success };
    case GET_REMINDERS:
      return { ...state, reminderList: action.payload.data };
    case UPDATE_REMINDER:
      return { ...state, reminderUpdateStatus: action.payload.success };
    case DELETE_REMINDER:
      return {
        ...state,
        reminderList: state.reminderList.filter(
          (item) => item.id !== action.reminderId,
        ),
        reminderDeleteStatus: action.payload.success,
      };
    case CREATE_MANUAL_SMS:
      return {
        ...state,
        manualSmsSaveStatus: action.payload.success,
      };
    case GET_MANUAL_SMS:
      return {
        ...state,
        manualSmsList: action.payload.data,
      };

    case UPDATE_MANUAL_SMS:
      return {
        ...state,
        manualSmsUpdateStatus: action.payload.success,
      };

    case DELETE_MANUAL_SMS:
      return {
        ...state,
        manualSmsList: state.manualSmsList.filter(
          (item) => item.id !== action.smsId,
        ),
        manualSmsDeleteStatus: action.payload.success,
      };
    case SEND_MANUAL_EMAIL:
      return {
        ...state,
        manualEmailStatus: action.payload.success,
      };
    case GET_MANUAL_EMAIL:
      return {
        ...state,
        manualEmailList: action.payload.data,
      };

    case UPDATE_MANUAL_EMAIL:
      return {
        ...state,
        manualEmailUpdateStatus: action.payload.success,
      };

    case DELETE_MANUAL_EMAIL:
      return {
        ...state,
        manualEmailList: state.manualEmailList.filter(
          (item) => item.id !== action.emailId,
        ),
        manualEmailDeleteStatus: action.payload.success,
      };
    default:
      return state;
  }
}
